import {EntitySubType, EntityType} from 'smag-commons/cfg/hierarchy';

export const environment = {
    production: true,
    rootPath: '/api',
    domainPrefix: '',
    proxyAuthCommons: null,
    permissionsEnabled: true,
    copyright: '© $YEAR$ Astolia S.r.l.',
    address: '',
    cookiesLink: 'https://s3.eu-west-1.amazonaws.com/assets-cer.brainwatt.it/Cookie+Policy+Brainwatt.pdf', // maps default
    customerCareRequests: {
        technical: 'Report a technical problem (related to the use of the platform or mobile app)',
        business: 'Business-type request (information about a product or service)',
        other: 'Other (to be specified in the message)'
    },
    defaultColor: '#333',
    appColors: {
        consolidatedGenerated: '#4A3A99',
        consolidatedSelfConsumed: '#996300',
        consolidatedShared: '#0e1e1f',
        consolidatedAbsorbed: '#852633',
        consolidatedSelfConsumedRatio: '#83268f',
        consolidatedIncentiveShared: '#0f4729',
        consolidatedInjected: '#111638',
        consolidatedConsumed: '#994979',
        consolidatedAbsorptionShare: '#145450',
        consolidatedEffectiveInjected: '#275B8F',
        consolidatedTIP: '#4E0359',
        consolidatedInjectionShare: '#174D5E',
        consolidatedCacv: '#663F1C',
        consolidatedSharedRatio: '#55732E',
        effectiveInjectedEnergy: '#439DF6',
incentivizedEffectiveInjected: '#E042F5',
incentivizedConsolidatedEffectiveInjected: '#83268F',
incentivizedConsolidatedShared: '#0F4729',
incentivizedShared: '#2AC874',
        selfConsumedEnergy: '#FFA500',
        selfConsumedRatio: '#E042F5',
        sharedEnergyRatio: '#8EC04D',
        activePower: '#1976D2',
        reactivePower: '#7B1FA2',
        thermalPower: '#F57C00',
        sharedPower: '#3B8285',
        injectedPower: '#303F9F',
        curtailedPower: '#0097A7',
        consumedPower: '#FF79C9',
        absorbedPower: '#EB445A',
        generatedPower: '#7B61FF',
        storagePower: '#616161',
        stateOfCharge: '#455A64',
        voltage: '#FFA000',
        phaseAngle: '#C2185B',
        current: '#616161',
        frequency: '#616161',
        energy: '#616161',
        temperature: '#512DA8',
        radiation: '#FBC02D',
        dewPoint: '#616161',
        windChill: '#616161',
        heatIndex: '#616161',
        pressure: '#616161',
        humidity: '#616161',
        rainfall: '#1976D2',
        uv: '#7B1FA2',
        liftedIndex: '#616161',
        cloudCoverage: '#616161',
        windSpeed: '#616161',
        windDir: '#616161',
        windGusts: '#616161',
        brightness: '#616161',
        presence: '#616161',
        cost: '#E64A19',
        highCost: '#C62828',
        lowCost: '#E57373',
        highPrice: '#558B2F',
        lowPrice: '#AED581',
        incentive: '#689F38',
        ecoDarkGreen: '#1F7F4B',
        ecoGreen: '#29A664',
        ecoLightGreen: '#2AC874',
        ecoAquaGreen: '#2DBAA1',
        ecoRed: '#FA6363',
        ecoOrange: '#F57C0BDB',
        ecoDarkBlue: '#3B71AF',
        ecoBlue: '#587BAF',
        ecoLightBlue: '#71A3DE',
        ecoYellow: '#F49D1A',
        ecoGrey: '#A6A6A6',
        ecoLegend: '#808080',
        ecoDarkLegend: '#444444',
        ecoEmpty: '#EBEBEB',
totalIncentive: '#43A047',
tip: '#A70EB6',
cacv: '#CC7E37',
consolidatedIncentive: '#193B1A',
incentiveSharedEnergyRatio: 'rgba(14,224,66,0.96)',
consolidatedIncentiveSharedRatio: '#83268F'

    },
    fontFamily: 'Barlow',
    icons: {
        [EntityType.ROOT_NODE]: {
            undetermined: 'fal-sitemap'
        },
        [EntityType.POD]: {
            undetermined: 'fal-tachometer-alt'
        },
        [EntityType.PLANT]: {
            undetermined: 'fal-solar-panel',
            [EntitySubType.PV_PLANT]: 'fal-solar-panel',
            [EntitySubType.WIND_PLANT]: 'fal-wind'
        },
        [EntityType.ACCUMULATOR]: {
            undetermined: 'fal-battery-half'
        },
        [EntityType.ENERGY_COMMUNITY]: {
            undetermined: 'fal-users',
            [EntitySubType.RENEWABLE_ENERGY_COMMUNITY]: 'fal-users',
            [EntitySubType.COLLECTIVE_SELF_CONSUMPTION_GROUP]: 'fal-home-lg-alt'
        }
    },
    measuresShowCurrentValue: false,
    totpTTL: 10
};
